<div>
    @if (completedAt && certificateId) {
        <button
            type="button"
            [class]="
                'btn-primary action-button w-full' +
                ' ' +
                buttonUi.buttonCss +
                ' ' +
                customButtonCss +
                ' ' +
                (isDetailsPage ? 'details-page-button' : '')
            "
            (click)="onClick()">
            <mat-icon class="inline-block !w-4 flex-shrink-0" [svgIcon]="buttonUi.icon"></mat-icon>

            <div>
                {{ 'button.downloadCertificate' | translate }}
            </div>
        </button>
    } @else {
        <a
            [class]="
                'btn-primary action-button' +
                ' ' +
                buttonUi.buttonCss +
                ' ' +
                customButtonCss +
                ' ' +
                (isDetailsPage ? 'details-page-button' : '')
            "
            [routerLink]="[this.programRoute, this.programId]"
            (click)="onClick()">
            <mat-icon class="inline-block !w-4 flex-shrink-0" [svgIcon]="buttonUi.icon"></mat-icon>

            <div>
                {{ buttonUi.text | translate }}
            </div>
        </a>
    }
</div>
